export default {
	en: {
		translation: {
			uploader: {
				filesize: {
					na: "N/A",
					b: "{{size}} Bytes",
					k: "{{size}} KB",
					m: "{{size}} MB",
					g: "{{size}} GB",
					t: "{{size}} TB",
				},
				errors: {
					file_too_large: "File size ({{size}}) exceeds maximum allowed ({{allowed}})",
					max_dimensions_validation: "Image dimensions ({{width}}X{{height}}) are bigger than the maximum allowed: ({{maxWidth}}X{{maxHeight}})",
					min_dimensions_validation: "Image dimensions ({{width}}X{{height}}) are smaller than the minimum required: ({{minWidth}}X{{minHeight}})",
					unavailable: "NA",
					max_number_of_files: "Maximum number of files exceeded",
					allowed_formats: "File format not allowed",
					max_file_size: "File is too large",
					min_file_size: "File is too small"
				},

				close_mid_upload: "There are running uploads. Click OK to abort."
			},
		},
	},
};
